
import { defineComponent, onMounted, ref, onBeforeUpdate, PropType } from 'vue'
import { useStore } from '@/store/index'
import { getTagIdsQuery, TagIdsQueryItem } from '@/types/forms/tag-checkbox'
import { useRouter } from 'vue-router'
import BaseAccordionOpenIcon from '@/components/BaseAccordionOpenIcon.vue'
import { toArray } from '@/utils/array'
import { VideoAttributes } from '@/types/models/video'
import { TagAttributes } from '@/types/models/tag'

export default defineComponent({
  components: { BaseAccordionOpenIcon },
  props: {
    filterdVideos: {
      type: Array as PropType<VideoAttributes[]>,
      'default': () => ([]),
    },
  },
  setup(props) {
    const store = useStore()
    const router = useRouter()
    const isOpen = ref(false)
    const tagRef = ref<HTMLElement | undefined>(undefined)
    const hiddenTagIds = ref<number[]>([])
    const DEFAULT_HEIGHT = 46
    const heightStyle = ref(`height: ${DEFAULT_HEIGHT}px`)

    const switchHeightStyle = (scrollHeight: number) => {
      heightStyle.value = `height: ${scrollHeight}px`
    }

    const closeTagList = () => {
      switchHeightStyle(DEFAULT_HEIGHT)
      isOpen.value = false
    }

    const clickOpen = () => {
      isOpen.value = !isOpen.value
      const OPEN_HEIGHT = Number(tagRef.value?.scrollHeight)
      if (isOpen.value) {
        switchHeightStyle(OPEN_HEIGHT)
      } else {
        switchHeightStyle(DEFAULT_HEIGHT)
      }
    }

    const classSelected = (tag_id: number) => getTagIdsQuery().includes(`${tag_id}`) ? 'bg-gray-800 text-white border-gray-200 animate__animated animate__bounceIn' : 'bg-gray-100 border-gray-200'

    const routerPushAddTagIdsQuery = (tag_id: number) => {
      const tagIds = getTagIdsQuery()
      const strTagId = `${tag_id}`
      const resultTagIds: string[] = tagIds.includes(strTagId)
        ? tagIds.filter(n => n !== strTagId)
        : [...tagIds, strTagId]
  
      const queryTag: TagIdsQueryItem = {
        t: resultTagIds,
      }
      router.push({ name: 'VideoList', query: queryTag })
    }

    const clickTag = (tag_id: number) => {
      closeTagList()
      routerPushAddTagIdsQuery(tag_id)
    }

    const createAllTagIds = ():number[] => {
      return toArray(store.state.tag.tags).map((tag:TagAttributes) => tag.id)
    }

    const createShowVideoTagIds = ():number[] => {
      const showVideoTags = props.filterdVideos.map((showVideo:VideoAttributes) => showVideo.tags)
      return showVideoTags.map((tag) => toArray(tag).map((tag) => tag.id)).flat()
    }

    const createHiddenTagIds = (allTagIds:number[], showVideoTagIds:number[]):number[] => {
      return allTagIds.filter(i => showVideoTagIds.indexOf(i) === -1)
    }

    onBeforeUpdate(() => {
      hiddenTagIds.value = createHiddenTagIds(createAllTagIds(), createShowVideoTagIds())
    })

    onMounted(() => {
      store.dispatch('tag/fetchTags')
    })

    return {
      store,
      clickTag,
      classSelected,
      switchHeightStyle,
      clickOpen,
      tagRef,
      isOpen,
      hiddenTagIds,
      heightStyle
    }
  },
})
